import { Card, CardMedia, CardActions, CardContent, Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"

import pdiImage from '../../assets/images/pdi-flowchart.png'


const ProductDatabaseIntegration = ({ openPDI, setOpenPDI }) => {
  return (
    <>
      <Card sx={{ minWidth: 250, backgroundColor: '#18122B', margin: '1rem' }}>
        <CardMedia
          sx={{ height: 200 }}
          image={pdiImage}
          title='Product Database Integration'
        />
        <CardContent>
          <Typography variant='h6' textAlign='center' sx={{ color: '#EDEBF7' }}>
            <strong>Product Database Integration</strong>
          </Typography>
        </CardContent>
        <CardActions sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <Button
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
            variant="contained"
            onClick={() => setOpenPDI(true)}
          >
            <strong>View More</strong>
          </Button>
        </CardActions>
      </Card>

      <Dialog
        fullWidth
        maxWidth='md'
        open={openPDI}
        onClose={() => setOpenPDI(false)}
      >
        <DialogTitle textAlign='center' sx={{ backgroundColor: "#18122B", color: '#EDEBF7' }}>
          Product Database Integration
        </DialogTitle>
        <DialogContent sx={{ display: 'block', backgroundColor: "#18122B" }}>

          <Typography variant="body1" sx={{ color: '#EDEBF7' }}>
            Product database integration is a NodeJS application developed to enhance client's online presence on OLX marketplace. Here's a brief breakdown of what it accomplishes:
            <ul>
              <li>The application seamlessly syncs the client's product database with the OLX marketplace, ensuring that product information is always up-to-date without any manual fuss.</li>
              <li>It also takes care of the visuals – resizing images to perfection for the OLX platform. This ensures that products not only look good but also stand out, grabbing the attention of potential customers.</li>
              <li>Serves data feeds for marketing purposes through a custom API.</li>
            </ul>
            The application is containerized using Docker and deployed to cloud server.
          </Typography>
          <Typography variant="body1" sx={{ color: '#EDEBF7', marginTop: '1rem' }} component='div'>
            Technologies used:
            <ul>
              <li>Javascript</li>
              <li>Node.js</li>
              <li>Express.js</li>
              <li>Docker</li>
            </ul>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#18122B" }}>
          <Button
            onClick={() => setOpenPDI(false)}
            sx={{
              color: '#EDEBF7',
              backgroundColor: '#443C68',
              '&:hover': {
                backgroundColor: '#393053'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ProductDatabaseIntegration